import { render, staticRenderFns } from "./tabs-message.vue?vue&type=template&id=8ec40540&scoped=true&"
import script from "./tabs-message.vue?vue&type=script&lang=js&"
export * from "./tabs-message.vue?vue&type=script&lang=js&"
import style0 from "./tabs-message.vue?vue&type=style&index=0&id=8ec40540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec40540",
  null
  
)

export default component.exports